import styled from 'styled-components';

import { theme } from '../../../../common/ui/theme';
import { ScheduleLayout } from '../scheduleLayout';

export const PortCard = styled.div`
    border: 1px solid ${theme.colors.border.muted};
    border-radius: ${theme.radii[6]};
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: ${ScheduleLayout.CARD_WIDTH};
    height: ${ScheduleLayout.ROW_HEIGHT};
    gap: ${theme.space[16]};
    padding: ${theme.space[12]};
    box-shadow: ${theme.shadows.medium};
    background-color: ${theme.colors.background.default};
`;
